export const redColorTL = '#BC2023';
export const greenColorTL = '#0C6B37';
export const yellowColorTL = '#ffeb3a';
export const orangeColorTL = '#FFA500';
export const greyColorTL = '#F2F2F2';
export const blackColorTL = '#000000';
export const whiteColorTL = '#FFFFFF';
export const transparentTL = '#00000000';
